// The active Fish Year challenge season. Shared so Home.js's dashboard teaser and
// FishYear.js's actual board can never drift out of sync on which year they're tracking.
export const FISH_YEAR = 2026;
